(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cosmo-carousel-controller"] && !Shopify.designMode) return;
  try {
    const cosmoCarouselInstances = new Map();
const cosmoCarouselPending = new Set();
const cosmoCarouselFocusable = 'a[href],button,input,select,textarea,[tabindex],[contenteditable="true"]';
class CosmoScrollCarousel {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-carousel-track]');
    this.originals = this.track ? Array.from(this.track.children).filter(item => item.hasAttribute('data-carousel-slide')) : [];
    this.toggle = root.querySelector('[data-carousel-toggle]');
    this.current = root.querySelector('[data-carousel-current]');
    this.status = root.querySelector('[data-carousel-status]') || (this.current && this.current.parentElement);
    this.abort = new AbortController();
    this.frame = 0;
    this.visible = false;
    this.userPaused = false;
    this.hovered = false;
    this.pointerActive = false;
    this.disposed = false;
    this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.autoplay = root.dataset.autoplay === 'true';
    this.direction = root.dataset.autoplayDirection === 'previous' ? -1 : 1;
    if (!this.track || !this.originals.length) {
      if (this.toggle) this.toggle.hidden = true;
      return;
    }
    this.clones = [];
    const before = document.createDocumentFragment();
    const after = document.createDocumentFragment();
    this.originals.forEach((slide, index) => {
      slide.dataset.carouselIndex = index;
      for (const fragment of this.originals.length > 1 ? [before, after] : []) {
        const clone = slide.cloneNode(true);
        clone.removeAttribute('data-carousel-slide');
        clone.removeAttribute('id');
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('data-carousel-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        if (clone.matches(cosmoCarouselFocusable)) clone.tabIndex = -1;
        clone.querySelectorAll(cosmoCarouselFocusable).forEach(element => { element.tabIndex = -1; });
        clone.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
        fragment.append(clone);
        this.clones.push(clone);
      }
    });
    this.track.prepend(before);
    this.track.append(after);
    this.items = Array.from(this.track.children);
    const on = (target, event, callback, options = {}) => target.addEventListener(event, callback, { ...options, signal: this.abort.signal });
    on(this.track, 'focusin', event => {
      this.pause();
      this.revealFocused(event.target);
    });
    on(this.track, 'focusout', () => this.syncMotion());
    on(this.track, 'pointerdown', () => {
      this.pointerActive = true;
      this.pause();
    }, { passive: true, capture: true });
    on(document, 'pointerup', () => { this.pointerActive = false; }, { passive: true });
    on(document, 'pointercancel', () => { this.pointerActive = false; }, { passive: true });
    on(this.track, 'wheel', event => { if (Math.abs(event.deltaX) > 0) this.pause(); }, { passive: true });
    on(this.track, 'keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key) || event.target.matches('input,textarea,select')) return;
      event.preventDefault();
      this.pause();
      const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.originals.length - 1 : this.nearestIndex() + (event.key === 'ArrowLeft' ? -1 : 1);
      this.goTo(index, true);
    });
    on(this.track, 'scroll', () => this.updateStatus(), { passive: true });
    on(this.track, 'scrollend', () => {
      if (!this.track.contains(document.activeElement)) this.normalize();
    });
    on(root, 'pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.syncMotion(); } });
    on(root, 'pointerleave', event => { if (event.pointerType === 'mouse') { this.hovered = false; this.syncMotion(); } });
    const previous = root.querySelector('[data-carousel-previous]');
    const next = root.querySelector('[data-carousel-next]');
    if (previous) previous.disabled = this.originals.length < 2;
    if (next) next.disabled = this.originals.length < 2;
    if (previous) on(previous, 'click', () => { this.pause(); this.goTo(this.nearestIndex() - 1); });
    if (next) on(next, 'click', () => { this.pause(); this.goTo(this.nearestIndex() + 1); });
    if (this.toggle) on(this.toggle, 'click', () => { this.userPaused = !this.userPaused; this.syncMotion(); });
    on(document, 'visibilitychange', () => this.syncMotion());
    on(this.motion, 'change', () => this.syncMotion());
    on(root, 'shopify:block:select', event => {
      const slide = event.target.closest('[data-carousel-slide]');
      if (slide) { this.pause(); this.goTo(Number(slide.dataset.carouselIndex)); }
    });
    this.resize = new ResizeObserver(() => this.measure());
    this.resize.observe(this.track);
    this.originals.forEach(slide => this.resize.observe(slide));
    this.intersection = new IntersectionObserver(entries => {
      this.visible = entries.some(entry => entry.isIntersecting);
      this.syncMotion();
    });
    this.intersection.observe(root);
    this.measure();
  }
  measure() {
    if (this.disposed || !this.track || !this.originals.length) return;
    const fraction = this.width ? ((this.track.scrollLeft - this.start) / this.width) : 0;
    this.start = this.originals[0].offsetLeft;
    const firstAfter = this.track.children[this.originals.length * 2];
    this.width = firstAfter ? firstAfter.offsetLeft - this.start : 0;
    this.positions = this.items.map(item => ({ item, left: item.offsetLeft, center: item.offsetLeft + item.offsetWidth / 2, index: Number(item.dataset.carouselIndex) }));
    this.speed = Number(this.root.dataset.loopSeconds) > 0 ? this.width / Number(this.root.dataset.loopSeconds) : Number(this.root.dataset.autoplaySpeed) || 22;
    this.track.scrollLeft = this.start + fraction * this.width;
    this.autoPosition = this.track.scrollLeft;
    this.revealFocused(document.activeElement);
    this.updateStatus();
    this.syncMotion();
  }
  nearestIndex() {
    const center = this.track.scrollLeft + this.track.clientWidth / 2;
    let nearest = this.positions[0];
    for (const position of this.positions) if (Math.abs(position.center - center) < Math.abs(nearest.center - center)) nearest = position;
    return nearest.index;
  }
  revealFocused(target) {
    if (this.pointerActive || !target || !this.track.contains(target)) return;
    const slide = target.closest('[data-carousel-slide]');
    if (!slide) return;
    const left = slide.offsetLeft;
    const right = left + slide.offsetWidth;
    if (left < this.track.scrollLeft + 4 || right > this.track.scrollLeft + this.track.clientWidth - 4) {
      this.track.scrollTo({ left: left + slide.offsetWidth / 2 - this.track.clientWidth / 2, behavior: 'instant' });
    }
  }
  goTo(index, keyboard = false) {
    const normalized = ((index % this.originals.length) + this.originals.length) % this.originals.length;
    this.normalize();
    const slide = this.originals[normalized];
    if (keyboard && document.activeElement !== this.track) {
      const target = slide.matches(cosmoCarouselFocusable) ? slide : slide.querySelector(cosmoCarouselFocusable);
      if (target) target.focus({ preventScroll: true });
      else this.track.focus({ preventScroll: true });
    }
    this.track.scrollTo({ left: slide.offsetLeft + slide.offsetWidth / 2 - this.track.clientWidth / 2, behavior: this.motion.matches || keyboard ? 'instant' : 'smooth' });
    this.updateStatus();
  }
  normalize() {
    if (this.pointerActive || !this.width) return;
    const relative = ((this.track.scrollLeft - this.start) % this.width + this.width) % this.width;
    const position = this.start + relative;
    if (Math.abs(position - this.track.scrollLeft) > 1) this.track.scrollLeft = position;
  }
  pause() {
    this.userPaused = true;
    this.syncMotion();
  }
  syncMotion() {
    if (this.disposed || !this.track) return;
    const eligible = this.autoplay && this.originals.length > 1;
    if (this.toggle) {
      this.toggle.hidden = !eligible || this.motion.matches;
      this.toggle.setAttribute('aria-pressed', String(this.userPaused));
      this.toggle.textContent = this.userPaused ? this.toggle.dataset.play : this.toggle.dataset.pause;
    }
    const running = eligible && this.visible && !document.hidden && !this.motion.matches && !this.userPaused && !this.hovered && !this.track.contains(document.activeElement) && this.width > this.track.clientWidth;
    this.root.dataset.carouselRunning = String(Boolean(running));
    if (this.status) this.status.setAttribute('aria-live', running ? 'off' : 'polite');
    if (!running) {
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      return;
    }
    if (this.frame) return;
    this.previousTime = 0;
    this.autoPosition = this.track.scrollLeft;
    const tick = time => {
      if (this.disposed) return;
      if (this.previousTime) this.autoPosition += this.direction * this.speed * Math.min(time - this.previousTime, 50) / 1000;
      this.previousTime = time;
      this.autoPosition = this.start + ((this.autoPosition - this.start) % this.width + this.width) % this.width;
      this.track.scrollLeft = this.autoPosition;
      this.frame = requestAnimationFrame(tick);
    };
    this.frame = requestAnimationFrame(tick);
  }
  updateStatus() {
    if (!this.positions || !this.positions.length) return;
    const value = String(this.nearestIndex() + 1);
    if (this.current && this.current.textContent !== value) this.current.textContent = value;
  }
  destroy() {
    this.disposed = true;
    this.abort.abort();
    if (this.frame) cancelAnimationFrame(this.frame);
    if (this.resize) this.resize.disconnect();
    if (this.intersection) this.intersection.disconnect();
    if (this.clones) this.clones.forEach(clone => clone.remove());
    this.root.removeAttribute('data-carousel-running');
  }
}
function activateCosmoCarousel(root) {
  if (!cosmoCarouselPending.has(root) || cosmoCarouselInstances.has(root) || !root.isConnected) return;
  cosmoCarouselPending.delete(root);
  cosmoCarouselActivation.unobserve(root);
  const instance = new CosmoScrollCarousel(root);
  cosmoCarouselInstances.set(root, instance);
  root.querySelectorAll('img[data-carousel-src]').forEach(image => {
    const srcset = image.getAttribute('data-carousel-srcset');
    if (srcset) image.setAttribute('srcset', srcset);
    image.setAttribute('src', image.getAttribute('data-carousel-src'));
    image.removeAttribute('data-carousel-srcset');
    image.removeAttribute('data-carousel-src');
  });
}
const cosmoCarouselActivation = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) activateCosmoCarousel(entry.target);
  });
}, { rootMargin: '300px 0px' });
function initCosmoCarousels(scope = document) {
  const roots = [...(scope.matches && scope.matches('[data-cosmo-carousel]') ? [scope] : []), ...scope.querySelectorAll('[data-cosmo-carousel]')];
  roots.forEach(root => {
    if (!cosmoCarouselInstances.has(root) && !cosmoCarouselPending.has(root)) {
      cosmoCarouselPending.add(root);
      cosmoCarouselActivation.observe(root);
    }
  });
}
initCosmoCarousels();
document.addEventListener('focusin', event => {
  const root = event.target.closest('[data-cosmo-carousel]');
  if (root && event.target.matches(':focus-visible')) activateCosmoCarousel(root);
}, true);
document.addEventListener('shopify:section:load', event => initCosmoCarousels(event.target));
document.addEventListener('shopify:section:unload', event => {
  cosmoCarouselPending.forEach(root => {
    if (event.target === root || event.target.contains(root)) {
      cosmoCarouselActivation.unobserve(root);
      cosmoCarouselPending.delete(root);
    }
  });
  cosmoCarouselInstances.forEach((instance, root) => {
    if (event.target === root || event.target.contains(root)) {
      instance.destroy();
      cosmoCarouselInstances.delete(root);
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cosmo-deferred-media"] && !Shopify.designMode) return;
  try {
    const cosmoDeferredMediaPending = new Map();
const cosmoDeferredMediaObservers = new Map();
function releaseCosmoDeferredMedia(block) {
  const group = cosmoDeferredMediaPending.get(block);
  if (!group) return;
  group.observer.unobserve(block);
  group.blocks.delete(block);
  cosmoDeferredMediaPending.delete(block);
  if (!group.blocks.size) {
    group.observer.disconnect();
    cosmoDeferredMediaObservers.delete(group.margin);
  }
}
function hydrateCosmoDeferredMedia(block) {
  if (!block.isConnected || !block.hasAttribute('data-cosmo-deferred-media')) {
    releaseCosmoDeferredMedia(block);
    return;
  }
  block.querySelectorAll('[data-media-srcset]').forEach(element => {
    element.setAttribute('srcset', element.dataset.mediaSrcset);
    element.removeAttribute('data-media-srcset');
  });
  block.querySelectorAll('[data-media-src]').forEach(element => {
    element.setAttribute('src', element.dataset.mediaSrc);
    element.removeAttribute('data-media-src');
  });
  block.removeAttribute('data-cosmo-deferred-media');
  releaseCosmoDeferredMedia(block);
}
function initCosmoDeferredMedia(scope = document) {
  const blocks = [...(scope.matches && scope.matches('[data-cosmo-deferred-media]') ? [scope] : []), ...scope.querySelectorAll('[data-cosmo-deferred-media]')];
  if (!('IntersectionObserver' in window)) {
    blocks.forEach(hydrateCosmoDeferredMedia);
    return;
  }
  blocks.forEach(block => {
    if (cosmoDeferredMediaPending.has(block)) return;
    const rawMargin = block.getAttribute('data-media-margin');
    const parsedMargin = rawMargin && rawMargin.trim() !== '' ? Number(rawMargin) : 300;
    const margin = Number.isFinite(parsedMargin) && parsedMargin >= 0 ? Math.min(Math.round(parsedMargin), 1000) : 300;
    let group = cosmoDeferredMediaObservers.get(margin);
    if (!group) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && cosmoDeferredMediaPending.get(entry.target)?.observer === observer) hydrateCosmoDeferredMedia(entry.target);
        });
      }, { rootMargin: margin + 'px 0px' });
      group = { margin, observer, blocks: new Set() };
      cosmoDeferredMediaObservers.set(margin, group);
    }
    group.blocks.add(block);
    cosmoDeferredMediaPending.set(block, group);
    group.observer.observe(block);
  });
}
initCosmoDeferredMedia();
document.addEventListener('shopify:section:load', event => initCosmoDeferredMedia(event.target));
document.addEventListener('shopify:section:unload', event => {
  cosmoDeferredMediaPending.forEach((group, block) => {
    if (event.target === block || event.target.contains(block)) releaseCosmoDeferredMedia(block);
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cosmo-italian-design"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cosmo-line-art')) {
    customElements.define('cosmo-line-art', class extends HTMLElement {
      connectedCallback() {
        if (this.hasDrawn || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.hasDrawn = true;
          this.classList.add('is-drawing');
          this.observer.disconnect();
        }, { threshold: 0.35 });
        this.observer.observe(this);
      }
      disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cosmo-production-network"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cosmo-production-network')) {
    customElements.define('cosmo-production-network', class extends HTMLElement {
      connectedCallback() {
        if(this.ready) return;
        const source=this.querySelector('[data-production-data]');
        if(!source) return;
        try { this.data=JSON.parse(source.textContent); } catch { return; }
        this.ready=true;
        this.category=this.querySelector('[data-network-category]');
        this.region=this.querySelector('[data-network-region]');
        this.search=this.querySelector('[data-network-search]');
        this.list=this.querySelector('[data-network-list]');
        this.zone='all';
        this.selected=null;
        this.zones={nw:['Valle d’Aosta','Piemonte','Lombardia'],ne:['Trentino–Alto Adige','Veneto','Friuli-Venezia Giulia','Emilia-Romagna'],central:['Toscana','Umbria','Lazio'],adriatic:['Marche','Molise'],south:['Campania','Puglia','Basilicata','Calabria'],sicily:['Sicilia']};
        this.zonePositions={nw:[130,120,44,128],ne:[226,107,327,51],central:[244,251,122,265],adriatic:[307,269,376,236],south:[394,389,480,420],sicily:[333,552,402,586]};
        this.data.regions.forEach(r=>{r.zone=Object.keys(this.zones).find(z=>this.zones[z].includes(r.name));});
        const addOption=(select,value,text)=>{const o=document.createElement('option');o.value=value;o.textContent=text;select.append(o);};
        Object.entries(this.data.categories).forEach(([id,name])=>addOption(this.category,id,name));
        this.data.regions.forEach(r=>addOption(this.region,r.id,r.name));
        this.groups=[];
        const groupMap=new Map();
        this.data.profiles.forEach(p=>{
          const region=this.data.regions.find(r=>r.id===p.region);
          p.zone=region.zone;
          const key=[p.region,p.area,p.title].join('|');
          let group=groupMap.get(key);
          if(!group){group={...p,members:[],regionName:region.name};groupMap.set(key,group);this.groups.push(group);}
          group.members.push(p.id);
        });
        const svg=(tag,attrs)=>{const n=document.createElementNS('http://www.w3.org/2000/svg',tag);Object.entries(attrs).forEach(([k,v])=>n.setAttribute(k,v));return n;};
        const points=new Map();
        this.data.profiles.forEach(p=>{const key=p.x+','+p.y;if(!points.has(key)) points.set(key,{x:p.x,y:p.y,ids:[]});points.get(key).ids.push(p.id);});
        this.points=[...points.values()].map(p=>{p.node=svg('circle',{cx:p.x,cy:p.y,r:4});this.querySelector('[data-network-dots]').append(p.node);return p;});
        this.zoneButtons=[...this.querySelectorAll('[data-zone]')];
        this.zoneButtons.forEach((button,i)=>{
          const code=button.dataset.zone;
          const number=String(i+1).padStart(2,'0');
          const label=button.textContent.trim();
          const badge=document.createElement('span');badge.textContent=number;badge.setAttribute('aria-hidden','true');button.prepend(badge);
          const [x,y,lx,ly]=this.zonePositions[code];
          this.querySelector('[data-network-routes]').append(svg('path',{d:'M'+x+','+y+' L'+lx+','+ly}));
          const pin=document.createElement('button');pin.type='button';pin.className='cosmo-network__pin';pin.dataset.zone=code;pin.textContent=number;pin.style.setProperty('--x',lx/5.2+'%');pin.style.setProperty('--y',ly/6.3+'%');pin.setAttribute('aria-label',label);pin.setAttribute('aria-pressed','false');this.querySelector('[data-network-pins]').append(pin);
        });
        this.zoneButtons=[...this.querySelectorAll('[data-zone]')];
        this.onInput=event=>{if(event.target===this.region)this.zone='all';this.refresh();};
        this.onClick=event=>{
          const z=event.target.closest('[data-zone]');
          if(z){this.zone=z.dataset.zone;this.region.value='all';this.refresh();return;}
          const item=event.target.closest('[data-profile]');
          if(item){this.select(item.dataset.profile);return;}
          if(event.target.closest('[data-network-reset]')){this.zone='all';this.region.value='all';this.category.value='all';this.search.value='';this.refresh();}
        };
        this.addEventListener('input',this.onInput);
        this.addEventListener('change',this.onInput);
        this.addEventListener('click',this.onClick);
        this.querySelectorAll('.cosmo-network__controls,.cosmo-network__layout,.cosmo-network__zones').forEach(el=>el.hidden=false);
        this.refresh();
      }
      normal(value){return value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();}
      refresh(){
        const q=this.normal(this.search.value.trim());
        this.filtered=this.groups.filter(p=>(this.region.value==='all'||p.region===this.region.value)&&(this.zone==='all'||p.zone===this.zone)&&(this.category.value==='all'||p.category===this.category.value)&&(!q||this.normal([p.title,p.area,p.regionName,p.note,this.data.categories[p.category]].join(' ')).includes(q)));
        const regionName=this.data.regions.find(r=>r.id===this.region.value)?.name;
        const zoneName=this.querySelector('.cosmo-network__zones [data-zone="'+this.zone+'"]')?.textContent.replace(/^\d+/,'').trim();
        this.querySelector('[data-network-heading]').textContent=regionName||zoneName||this.dataset.allRegions;
        const count=this.filtered.length;
        this.querySelector('[data-network-count]').textContent=count+' '+(count===1?this.dataset.profileLabel:this.dataset.profilesLabel);
        this.zoneButtons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.zone===this.zone)));
        const fragment=document.createDocumentFragment();
        this.filtered.forEach(p=>{const button=document.createElement('button');button.type='button';button.className='cosmo-network__item';button.dataset.profile=p.id;button.setAttribute('aria-pressed','false');const title=document.createElement('strong');title.textContent=p.title;const area=document.createElement('span');area.textContent=p.area===p.regionName?p.area:p.area+' · '+p.regionName;button.append(title,area);if(p.members.length>1){const count=document.createElement('small');count.textContent=p.members.length+' '+this.dataset.partnersLabel;button.append(count);}const note=document.createElement('em');note.textContent=p.note;note.hidden=true;button.append(note);fragment.append(button);});
        this.list.replaceChildren(fragment);
        this.list.scrollTop=0;
        this.querySelector('[data-network-empty]').hidden=this.filtered.length>0;
        this.select(this.filtered.some(p=>p.id===this.selected)?this.selected:this.filtered[0]?.id);
      }
      select(id){
        this.selected=id;
        const p=this.filtered.find(g=>g.id===id);
        this.list.querySelectorAll('[data-profile]').forEach(b=>{const active=b.dataset.profile===id;b.setAttribute('aria-pressed',String(active));b.querySelector('em').hidden=!active;});
        const visible=new Set(this.filtered.flatMap(g=>g.members));
        this.points.forEach(point=>{point.node.classList.toggle('is-muted',!point.ids.some(id=>visible.has(id)));point.node.classList.toggle('is-selected',!!p&&point.x===p.x&&point.y===p.y);});
        const ring=this.querySelector('[data-network-ring]');
        ring.toggleAttribute('hidden',!p);
        if(p){ring.setAttribute('cx',p.x);ring.setAttribute('cy',p.y);}
        this.querySelector('[data-network-place]').textContent=p?(p.area===p.regionName?p.area:p.area+' · '+p.regionName):'';
        this.querySelector('[data-network-title]').textContent=p?p.title:this.dataset.allRegions;
        this.querySelector('[data-network-note]').textContent=p?p.note:'';
      }
      disconnectedCallback(){
        this.removeEventListener('input',this.onInput);this.removeEventListener('change',this.onInput);this.removeEventListener('click',this.onClick);
        if(!this.ready)return;
        this.category.querySelectorAll('option:not(:first-child)').forEach(o=>o.remove());this.region.querySelectorAll('option:not(:first-child)').forEach(o=>o.remove());
        ['[data-network-dots]','[data-network-routes]','[data-network-pins]'].forEach(s=>this.querySelector(s).replaceChildren());
        this.querySelectorAll('.cosmo-network__zones button span').forEach(s=>s.remove());this.ready=false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["la-bottega-farm-story"] && !Shopify.designMode) return;
  try {
    function observeLaBottegaStory(scope=document){
  const stories=scope.querySelectorAll('.lb-farm-story');
  if(!('IntersectionObserver' in window)){stories.forEach(story=>story.classList.add('lb-farm-story--ready'));return}
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('lb-farm-story--ready');observer.unobserve(entry.target)}}),{rootMargin:'500px'});
  stories.forEach(story=>observer.observe(story));
  if(scope!==document) scope.addEventListener('shopify:section:unload',()=>observer.disconnect(),{once:true});
}
observeLaBottegaStory();document.addEventListener('shopify:section:load',event=>observeLaBottegaStory(event.target));
  } catch(e) { console.error(e); }
})();

})();
